import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=85d332b6&scoped=true"
import script from "./ProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=85d332b6&prod&lang=css"
import style1 from "./ProductComponent.vue?vue&type=style&index=1&id=85d332b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d332b6",
  null
  
)

export default component.exports